import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { initTheme } from '@hzero-front-ui/core';
import { theme1, theme3, theme2, theme5 } from '@hzero-front-ui/themes';
import HzeroTmp from '@hzero-front-ui/hzero-ui';
import C7nTmp from '@hzero-front-ui/c7n-ui';
import { inject } from 'what-di';
import uniq from 'lodash/uniq';
import { NO_UED_SCOPE_SELECTOR } from "../../components/Page/NoUedWrapper";
import { LayoutComponent, C7nPolyfill } from "../../components/UedTheme";
import { theme1ExtraData, theme3ExtraData, theme5ExtraData, theme1ImageData, theme2ImageData, theme3ImageData } from "./uedData";
import { UedProvider } from "./UedProvider";
var defaultScope = [NO_UED_SCOPE_SELECTOR, '[class*="c7n-pro-popup-container"]', '[class*="c7n-pro-modal-container"]', '.c7n-modal', '.c7n-popover', '.ant-popover', '.ant-modal-wrap ', '.ant-drawer'];
var defaultOpts = {
  defaultTheme: 'peacock',
  themes: [{
    name: 'iceflow',
    data: _objectSpread({}, theme1, {
      layout: theme1ExtraData,
      images: theme1ImageData
    })
  }, {
    name: 'peacock',
    data: _objectSpread({}, theme2, {
      images: theme2ImageData
    })
  }, {
    name: 'aurora',
    data: _objectSpread({}, theme3, {
      layout: theme3ExtraData,
      images: theme3ImageData
    })
  },
  // { name: 'theme4', data: { ...theme2, images: theme2ImageData } },
  {
    name: 'nightingale',
    data: _objectSpread({}, theme5, {
      layout: theme5ExtraData,
      images: theme2ImageData
    })
  } // { name: 'theme4', data: theme4 },
  ],

  templates: [{
    id: 'hzero',
    component: HzeroTmp
  }, {
    id: 'c7n',
    component: C7nTmp
  }, {
    id: 'c7n-polyfill',
    component: C7nPolyfill
  }, {
    id: 'hzero-layout',
    component: LayoutComponent
  }]
};
export var defaultInit = function defaultInit() {
  initTheme(defaultOpts);
};
export function overrideThemeInit(init) {
  var ued = inject(UedProvider);
  var scoped = init.scoped,
    _init$scope = init.scope,
    scope = _init$scope === void 0 ? [] : _init$scope,
    rest = _objectWithoutProperties(init, ["scoped", "scope"]);
  window.__UED__SCOPE__ENABLED__ = scoped;
  var scopeList = _toConsumableArray(scope);
  if (scoped) {
    scopeList.push.apply(scopeList, defaultScope);
  }
  ued.setState(_objectSpread({}, ued.state, {
    initFunction: function initFunction() {
      return initTheme(_objectSpread({}, defaultOpts, {}, rest, {
        scope: uniq(scopeList)
      }));
    }
  }));
}